import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import {
  pause,
  resume,
  setFocus,
} from '@noriginmedia/norigin-spatial-navigation'
import SidePanel from './SidePanel'
import MainContent from './MainContent'
import LogoHeader from '../LogoHeader'
import { useSidePanel } from './SidePanelProvider'
import ExitAppModal from '../ExitAppModal'

import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'
import cx from 'classnames'
import { platformTransitionStyle } from '../../../../shared/helpers'
import { useAppSelector } from '../../hooks/useStore'

export const SidePanelLayout = () => {
  const { isSidePanelFocused, isLogoHidden } = useSidePanel()
  const [showExitAppModal, setShowExitAppModal] = useState(false)
  const showingScreenSaver = useAppSelector(
    (state) => state.screensaver.showing
  )
  // Workaround to allow new focus components to work with spatial navigation and old components work with focusable HoC
  // TODO: remove this when whole app is migrated to react spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  useEffect(() => {
    if (showingScreenSaver) {
      pause()
    } else {
      setTimeout(() => resume())
    }
  }, [showingScreenSaver])

  useKeyDown(KeyTypeEnum.Back, () => {
    if (isSidePanelFocused) {
      setShowExitAppModal(true)
    } else {
      setFocus('SIDE_PANEL')
    }
  })

  const handleCancel = () => {
    setShowExitAppModal(false)
    setFocus('SIDE_PANEL')
  }

  return (
    <>
      {showExitAppModal && <ExitAppModal onCancel={handleCancel} />}
      <div
        className="side-panel-layout"
        id="side-panel-layout"
        style={{ visibility: showExitAppModal ? 'hidden' : 'visible' }}
      >
        <div
          className="side-panel-layout__full-width-background"
          id="full-width-background"
        ></div>
        <div
          style={{
            transition: platformTransitionStyle('transform 500ms linear'),
          }}
          className={cx('side-panel-layout__header', {
            'side-panel-layout__header--hidden': isLogoHidden,
          })}
        >
          <LogoHeader />
        </div>
        <div className="side-panel-layout__content">
          <SidePanel />
          <MainContent>
            <Outlet />
          </MainContent>
        </div>
      </div>
    </>
  )
}
